import React, { Component } from 'react';
import Vitae from '../../common/generateCurriculumVitae';
import SideNav from '../SideNav';

class GenerateCurriculumVitae extends Component {
    render() {
        return (
            <div className="content">
                <SideNav selectKey='curriculumVitae' />
                <div className="main">
                    <div className="main-content">
                        <Vitae type="personal" />
                    </div>
                </div>
            </div>
        );
    }
}

export default GenerateCurriculumVitae;


// WEBPACK FOOTER //
// ./src/components/personal/generateCurriculumVitae/index.js